import React from "react";
// import NavBar from "../../components/navBar";
import Footer from "../../components/footer";
import HeaderParallax from "../../components/home/headerParallax";
import AboutUs from "../../components/home/aboutUs";
import ReactPlayer from "react-player";
import "./style.css";

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="homePage">
        {/* <NavBar /> */}
        <HeaderParallax />
        {/* <AboutUs />

        <div
          className="page-header section-dark headerParallax"
          style={{
            backgroundImage:
              "url(" + require("../../Images/introVidBanner.jpg") + ")",
          }}
        ></div>
        <Products></Products> */}
        <Footer />
      </div>
    );
  }
}

export default Home;
